import { FormLineV2 } from "@Modules/common/Form/FormLineV2";
import { classNames } from "repoV2/utils/common/render/classNames";
import React, { FC } from "react";
import { evaluateHideComponent } from "@Modules/eventPage/utils/render";
import { SidebarSectionDivider } from "../SidebarSectionDivider";
import { IPlanDropdown } from "./IPlanDropdown";
import styles from "./planDropdown.module.scss";
import commonStyles from "../commonStyles.module.scss";
import { DetailsSectionDivider } from "../DetailsSectionDivider";
import { getCustomStyle } from "./planDropdown.styles";
import { usePlanDropdownContext } from "./utils/PlanDropdownContext";

const PlanDropdown: FC<IPlanDropdown.IProps> = props => {
    const {
        hideComponent,
        handleChange,
        getDropdownSelectorsProps,
        selectionPathToRender,
        loading,
        planMetadata,
    } = usePlanDropdownContext();

    const { planDropdownRef, showOn, isMobile } = props;

    if (evaluateHideComponent({ hideComponent, isMobile, showOn })) return null;

    const customStyle = getCustomStyle(isMobile) as IPlanDropdown.StyleType;

    const mainComponent = loading ? (
        <div className={classNames("loader8", styles.loader)} />
    ) : (
        <div className={styles.root}>
            {selectionPathToRender.map((path, depthIndex) => {
                const {
                    value: selectedValue,
                    isLeaf,
                    options,
                    categoryName,
                    categoryTitle,
                } = getDropdownSelectorsProps(depthIndex);

                const showRecommendedTag = planMetadata?.show_recommended_tag;
                const finalOptions = options.map(option => ({
                    ...option,
                    is_recommended: option.is_recommended
                        ? showRecommendedTag
                        : option.is_recommended,
                }));

                return (
                    <div
                        // eslint-disable-next-line react/no-array-index-key
                        key={`${categoryTitle}-${depthIndex}`}
                    >
                        <FormLineV2
                            field={{
                                label:
                                    depthIndex === 0
                                        ? ""
                                        : categoryTitle || categoryName || "",
                                inputType: "select",
                                value: selectedValue,
                                options: finalOptions,
                                id: "scheduleDropdown-classSchedule",
                                onChange: (
                                    val: IPlanDropdown.OptionType | null
                                ) => {
                                    if (selectedValue?.value !== val?.value)
                                        handleChange({
                                            val,
                                            depth: depthIndex,
                                            isLeaf,
                                        });
                                },
                                isSearchable: false,
                                key: "classSelect",
                                design: "custom",
                                styles: customStyle,
                                placeholder:
                                    planMetadata?.default_plan_text ||
                                    "Select an Offering",
                            }}
                            classNames={{
                                label: classNames(styles.title, "mt-2 mb-0"),
                            }}
                        />
                    </div>
                );
            })}
        </div>
    );

    return isMobile ? (
        <>
            <div ref={planDropdownRef} className={styles.ref} />
            <div className={commonStyles.detailsSectionTitle}>
                {planMetadata?.default_plan_text || "Choose a Plan"}
            </div>
            <div className={commonStyles.detailsSectionBody}>
                {mainComponent}
            </div>
            <DetailsSectionDivider />
        </>
    ) : (
        <>
            <div className={commonStyles.sidebarSectionTitle}>
                {planMetadata?.default_plan_text || "Choose a Plan"}
            </div>
            {mainComponent}
            <SidebarSectionDivider />
        </>
    );
};

export default PlanDropdown;
